import React from 'react';
import PropTypes from 'prop-types';
import './Divider.scss';

const Divider = ({ size }) => <div className={`divider divider--${size}`} />;

Divider.defaultProps = {
  size: 'regular',
};

Divider.propTypes = {
  size: PropTypes.string,
};

export default Divider;
